import SubmenuLink from './SubmenuLink'
export default SubmenuLink



// WEBPACK FOOTER //
// ./src/atoms/SubmenuLink/index.js